import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { mainRoutes } from "../../utils/routingUtils/routeList.js";
import { LinearProgress, Stack, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setUserAuth } from "../../store/slices/user_auth_slice";
import { PublicRoutes } from "./Public_Routes/PublicRoutes.js";
import { PrivateRoutes } from "./Private_Routes/PrivateRoutes.js";
import { asyncStatus, save_tokens_constant } from "../../utils/contants/asyncStatus.js";
import { exit_session } from "../apiHandle.js";
import { check_auth } from "../../store/services/authentication.js";

export const RouterApp = () => {
  const { check_auth_status } = useSelector((state) => state.userAuth);

  const dispatch = useDispatch();

  useEffect(() => {
    if (check_auth_status === asyncStatus.IDLE) {
      const authTokens =
        localStorage.getItem(save_tokens_constant.AUTH) || null;
      if (!authTokens) {
        dispatch(setUserAuth(false));
      } else {
        dispatch(check_auth());
        console.log("", authTokens);
      }
    }
  }, []);

  if (check_auth_status === asyncStatus.LOADING) {
    return (
      <Stack>
        <LinearProgress />
      </Stack>
    );
  }

  if (check_auth_status === asyncStatus.ERROR) {
    return (
      <Stack py={2}>
        <Typography align="center" color="red">
          Something went wrong!
        </Typography>
        <Typography
          onClick={() => exit_session()}
          mt={5}
          sx={{ cursor: "pointer" }}
          align="center"
          color="red"
        >
          Back to home
        </Typography>
      </Stack>
    );
  }

  return (
    <Router>
      <Routes>
        <Route element={<PublicRoutes />}>
          {React.Children.toArray(
            mainRoutes.map((route, i) => {
              const { linkTo, element, authRequired, both } = route;
              return (
                !authRequired && (
                  <Route key={i} element={element} path={linkTo} />
                )
              );
            })
          )}
        </Route>
        <Route element={<PrivateRoutes />}>
        {/* <Route> */}
          {React.Children.toArray(
            mainRoutes.map((route, i) => {
              const { linkTo, element, authRequired, both } = route;
              return (
                authRequired && (
                  <Route key={i} element={element} path={linkTo} />
                )
              );
            })
          )}
        </Route>
      </Routes>
    </Router>
  );
};
